const ACCEPTED_IMAGES = ['image/jpeg', 'image/png', 'image/bmp', 'image/tiff', 'image/gif']

export const isVideo = type => type === 'video/mp4'

export const isImage = type => ACCEPTED_IMAGES.includes(type)
